import logo from './logo.svg';
import './App.css';
import Home from './Home';
import Nav from './components/nav';
import Footer from './components/footer';

function App() {
  return (
    <div className="App">
      <Home/>
      <Footer/>
    </div>
  );
}

export default App;
